import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { getHotelAdmins } from "../store/slices/auth";
import { Col } from "react-bootstrap";
import userimg from "../assets/images/admin.png";
import userback from "../assets/images/2785.jpg";
import { gethotelList, editHotelDetails } from "../store/slices/hotel";
import ShowSkeleton from "../utils/helpers/skeleton";
import { Icon } from "@iconify/react";
import StatusModal from "../utils/Modals/statusModal";

const HotelAdminDetails = () => {
  const { id } = useParams();
  const [hotelData, setHotelData] = useState([]);
  const [fullName, setfullName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [username, setUsername] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedItem, setSelectedItem] = useState(null);
  const [actionType, setActionType] = useState("");
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    fetchHAdminDetails();
    fetchHotelList();
  }, []);

  const fetchHAdminDetails = () => {
    let item = { id };
    dispatch(getHotelAdmins(item))
      .unwrap()
      .then((data) => {
        setfullName(data?.adminData[0].fullName || "");
        setUsername(data?.adminData[0].username || "");
        setMobile(data?.adminData[0].mobile || "");
        setEmail(data?.adminData[0].email || "");
      })
      .catch(({ message }) => console.error(message))
      .finally(() => {
        setIsLoading(false);
      });
  };

  const fetchHotelList = () => {
    const hotelAdminId = id;
    let item = { hotelAdminId };
    dispatch(gethotelList(item))
      .unwrap()
      .then((data) => {
        setHotelData(data?.hotelData || []);
      })
      .catch(({ message }) => console.error(message))
      .finally(() => {
        setIsLoading(false);
      });
  };

  const openStatusModal = (_id, isApproved) => {
    setSelectedItem({ id: _id, isApproved });
    setActionType(isApproved === true ? "deactivate" : "activate");
    setShowModal(true);
  };

  const handleStatusChange = () => {
    if (selectedItem) {
      const { id, isApproved } = selectedItem;
      const updatedStatus = isApproved === true ? false : true;

      const payload = {
        id,
        isApproved: updatedStatus,
      };

      dispatch(editHotelDetails(payload))
        .unwrap()
        .then(() => {
          fetchHotelList();
          setShowModal(false);
        })
        .catch((error) => {
          console.error("Status update error: ", error);
        });
    } else {
      console.error("No selected item set.");
    }
  };

  return (
    <>
      <StatusModal
        showModal={showModal}
        actionType={actionType}
        setShowModal={setShowModal}
        handleDelete={handleStatusChange}
      />
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
        <h6 className="fw-semibold mb-0">Hotel Owner Details</h6>
        <ul className="d-flex align-items-center gap-2">
          <li className="fw-medium">
            <Link
              to="/admin/hoteladmin"
              className="d-flex align-items-center gap-1 hover-text-primary"
            >
              Hotel Admin
            </Link>
          </li>
          <li> &gt; </li>
          <li className="fw-medium">Hotel Owner Details</li>
        </ul>
      </div>

      <div className="row gy-4">
        <div className="col-lg-3">
          <div className="user-grid-card position-relative border radius-16 overflow-hidden bg-base h-100">
            <img src={userback} alt="" className="w-100 object-fit-cover" />
            <div className="pb-24 ms-16 mb-24 me-16  mt--110">
              <div className="text-center border border-top-0 border-start-0 border-end-0">
                <img
                  src={userimg}
                  alt=""
                  className="border br-white border-width-2-px w-120-px h-120-px rounded-circle object-fit-cover"
                />
                <h6 className="mb-0 mt-16">{fullName}</h6>
                <span
                  style={{ fontSize: "14px" }}
                  className="text-secondary-light mb-16"
                >
                  {email}
                </span>
              </div>
              <div className="mt-24">
                <h6 className="text-md mb-16">Personal Info</h6>
                <ul>
                  <li className="d-flex align-items-center gap-1 mb-12">
                    <span className="w-30 text-md fw-semibold text-primary-light">
                      Mobile
                    </span>
                    <span className="w-70 text-secondary-light fw-medium">
                      : {mobile}
                    </span>
                  </li>
                  <li className="d-flex align-items-center gap-1 mb-12">
                    <span className="w-30 text-md fw-semibold text-primary-light">
                      {" "}
                      Username
                    </span>
                    <span className="w-70 text-secondary-light fw-medium">
                      : {username}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-9">
          <div className="card h-100">
            <div className="card-body p-24">
              <h6>Properties</h6>
              <div className="table-responsive scroll-sm">
                {isLoading ? (
                  <Col lg={12} xs={12} md={12} align="center">
                    {ShowSkeleton()}
                  </Col>
                ) : (
                  <table className="table striped-table mb-0">
                    <thead>
                      <tr>
                        <th scope="col">
                          <div className="d-flex align-items-center gap-10">
                            S.L
                          </div>
                        </th>

                        <th scope="col">Property Name</th>

                        <th scope="col">Property Type</th>

                        <th scope="col" className="text-center">
                          Status
                        </th>
                        <th scope="col">Platform Charges</th>
                        <th scope="col" className="text-center">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {hotelData?.map((item, index) => (
                        <tr key={index}>
                          <td>
                            <div className="d-flex align-items-center gap-10">
                              {index + 1}
                            </div>
                          </td>

                          <td>
                            <div className="d-flex align-items-center">
                              <div className="flex-grow-1">
                                <span className="text-md mb-0 fw-normal text-secondary-light">
                                  {item.name}
                                </span>
                              </div>
                            </div>
                          </td>

                          <td>
                            <div className="d-flex align-items-center">
                              <div className="flex-grow-1">
                                <span className="text-md mb-0 fw-normal text-secondary-light">
                                  {item.propertyType.name}
                                </span>
                              </div>
                            </div>
                          </td>

                          <td className="d-flex align-items-center gap-10">
                            {item.isApproved === false ? (
                              <Link
                                onClick={() =>
                                  openStatusModal(item._id, item.isApproved)
                                }
                                className="bg-danger-focus text-danger-600 bg-hover-danger-200 fw-medium d-flex justify-content-center align-items-center"
                                style={{
                                  borderRadius: "10px",
                                  padding: "2px",
                                  width: "90px",
                                  fontSize: "14px",
                                }}
                              >
                                Deactivate
                              </Link>
                            ) : (
                              <Link
                                onClick={() =>
                                  openStatusModal(item._id, item.isApproved)
                                }
                                className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium d-flex justify-content-center align-items-center"
                                style={{
                                  borderRadius: "10px",
                                  padding: "2px",
                                  fontSize: "14px",
                                  width: "90px",
                                }}
                              >
                                Activate
                              </Link>
                            )}
                          </td>
                          <td>
                            <div className="text-center">
                              {item.platformCharges}%
                            </div>
                          </td>

                          <td className="text-center">
                            <div className="d-flex align-items-center gap-10 justify-content-center">
                              {/* <Link
                                to={`/admin/hoteladmin-details/${item._id}`}
                                className="bg-warning-focus text-warning-600 bg-hover-warning-200 fw-medium w-32-px h-32-px d-flex justify-content-center align-items-center rounded-circle"
                              >
                                <Icon icon="lucide:eye" className="menu-icon" />
                              </Link> */}
                              <Link
                                to={`/admin/edit-hotel/${item._id}`}
                                className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-32-px h-32-px d-flex justify-content-center align-items-center rounded-circle"
                              >
                                <Icon
                                  icon="lucide:edit"
                                  className="menu-icon"
                                />
                              </Link>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HotelAdminDetails;
